module.exports = __webpack_public_path__ + "img/5C4E41_CCCDD6_9B979B_B1AFB0-256px.6a110e8e.png";